export default __webpack_public_path__ + "pgnv-assets/2c0453fd48aac094e459b9e4f112d4dd.png";